@if (basket().recurrence) {
<div class="address-summary">
  <h3>{{ 'account.subscription.heading' | translate }}</h3>
  <div class="row">
    <span class="col-6">{{ 'subscriptions.list.table.recurrence' | translate }}:</span>
    <span class="col-6 text-right">{{ basket().recurrence.interval | customSubscriptionIntervalFormatter }}</span>
  </div>
  <div class="row">
    <span class="col-6">{{ 'account.subscriptiondetails.start_date.label' | translate }}:</span>
    <span class="col-6 text-right"> {{ basket().recurrence?.startDate | date : 'MM/dd/yy' }} </span>
  </div>
  <div class="row">
    <span class="col-6">{{ 'account.subscriptiondetails.end_date.label' | translate }}:</span>
    <span class="col-6 text-right">
      {{ basket().recurrence?.endDate ? (basket().recurrence?.endDate | date : 'MM/dd/yy') : '-' }}
    </span>
  </div>
</div>
}
